const DATA_API_HOST = process.env.DATA_API_HOST;
const PROTOCOL = window.location.href.split('/')[0];


export const ApiHttp = {
    uploadProjectFile(folder, file, fileName?: string) {
        return postRaw(`/upload-file/script-import/${folder}/${fileName || file.name}`, file);
    },
    uploadAlanBtnLogo(projectId, platform, fileName, file) {
        return postRaw(`/upload-image/${projectId}/btn-logo/${fileName}`, file);
    },
    createWakeWordModel(data) {
        return fetch(`https://alan-wakeword-srv-1-fsjrb2hbgq-uc.a.run.app/create_wakeword`, {
            method: 'POST',
            headers: new Headers({ 'content-type': 'application/json' }),
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(({ model_url }) => {
                return {
                    modelUrl: model_url
                };
            });
    }
};

export function getApiUrlPrefix() {
    return `${PROTOCOL}//${DATA_API_HOST}`
}

function postRaw(url, data) {
    return fetch(`${getApiUrlPrefix()}${url}`, {
        method: 'POST',
        body: data,
    });
}
